<template lang="html">
  <div>
    <terminal-group-item v-model="selectedItemId" />
    <v-card
      v-if="!showItemOnly"
      :key="instanceKey"
    >
      <page-bar
        :title="pageTitle"
        :context-menu="defaultContextMenu"
        :loading="isDataLoading"
      />

      <api-errors :errors="errors" />

      <!-- LIST OF ITEMS -->
      <item-select-table
        :add-action="addNewItem"
        :add-label="'Add ' + type"
        :edit-action="editItem"
        :search="true"
        :items="items"
        :pagination.sync="pagination"
        :total-items="totalListItems"
        :headers="headers"
      >
        <template
          slot="appMode"
          slot-scope="props"
        >
          <div>{{ appModeTypeMap[props.item.appMode].textShort }}</div>
        </template>
      </item-select-table>
    </v-card>
  </div>
</template>

<script>
import {itemSelect} from '@/ft-vue-core'
import TerminalGroupItem from './TerminalGroupItem'

export default {
  name: 'TerminalGroupList',
  components: {TerminalGroupItem},
  mixins: [itemSelect],
  data: function () {
    return {
      type: 'Terminal Group',
      types: 'Terminal Groups',
      appModes: [],
      headers: [
        this.headerText('Terminal Group', 'name', true),
        this.headerSlot('Type', 'appMode', true),
        this.headerInvertedSwitch('Active', 'disabled')
      ],
      apiRecordCommand: 'terminalGroup'
    }
  },
  computed: {
    appModeTypeMap () {
      return this.appModes.reduce((acc, b) => {
        acc[b.value] = b
        return acc
      }, {})
    }
  },
  methods: {
    listResourceCommands () {
      return [
        {
          command: 'apiFieldOption',
          load: this.appModes,
          loading: this.isLoading,
          params: {filter_methods: {forField: ['terminalGroup', 'appMode']}}
        }
      ]
    },
    listCommandFilter (command) {
      return this.addCommandParam(command, 'filter_methods', {filterFieldValue: ['appMode', this.$ftAPI().appMode()]})
    }
  }
}
</script>
